<template>
  <Modal title="审核状态" v-model="isShow" @on-cancel="handle" width="600">
    <div class="myModal">
        <Form ref="statusInfo"  :model='statusInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="审核状态" prop="status">
            <RadioGroup v-model="statusInfo.status">
              <Radio :label="1" class="radio">通过</Radio>
              <Radio :label="2">驳回</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="驳回原因" prop="remark" v-if="statusInfo.status ==2">
            <Input placeholder="请输入" v-model="statusInfo.remark"></Input>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { shen } from '@/api/goods/goods'
export default {
  name: 'agentEdit',
  props: ['editShow', 'id'],
  data () {
    return {
      isShow: false,
      statusInfo: {
        goods_id: 0,
        status: 1,
        remark: ''
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
      this.statusInfo.status = 1
      this.statusInfo.remark = ''
    },
    id (val) {
      this.statusInfo.goods_id = val
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel')
    },
    handleOk (name) {
      shen(this.statusInfo).then(res => {
        if (res.code === 200) {
          this.$Message.success(res.msg)
          this.$emit('updateStatusModel')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
